<template>
  <div class="login-logs-container">
    <el-card>
      <div slot="header" class="card-header">
        <span class="title">
          <i class="el-icon-document"></i>
          登录记录
        </span>
      </div>

      <!-- 筛选条件 -->
      <div class="filter-section">
        <el-form :inline="true" :model="filterForm" class="filter-form">
          <el-form-item label="用户名">
            <el-input 
              v-model="filterForm.username" 
              placeholder="请输入用户名"
              clearable
              @clear="handleFilter"
            />
          </el-form-item>
          
          <el-form-item label="登录状态">
            <el-select 
              v-model="filterForm.status" 
              placeholder="请选择"
              clearable
              @clear="handleFilter"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="成功" :value="1"></el-option>
              <el-option label="失败" :value="0"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleFilter"
            />
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table 
        v-loading="loading"
        :data="logs" 
        style="width: 100%"
        stripe
      >
        <el-table-column type="index" label="序号" width="60" />
        
        <el-table-column prop="username" label="用户名" width="120" />
        
        <el-table-column prop="loginIp" label="IP地址" width="140" />
        
        <el-table-column prop="loginLocation" label="登录地点" width="100" />
        
        <el-table-column prop="browser" label="浏览器" width="100" />
        
        <el-table-column prop="os" label="操作系统" width="120" />
        
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="loginTime" label="登录时间" min-width="160">
          <template slot-scope="scope">
            {{ formatTime(scope.row.loginTime) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { authUtils } from '@/utils/auth'

export default {
  name: 'LoginLogs',
  data() {
    return {
      loading: false,
      logs: [],
      stats: {
        totalLogs: 0,
        successCount: 0,
        failedCount: 0
      },
      filterForm: {
        username: '',
        status: '',
        dateRange: []
      },
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    if (!authUtils.isAdmin()) {
      this.$message.warning('无权限访问管理后台，已自动返回文档列表')
      this.$router.replace('/')
      return
    }
    this.loadStats()
    this.loadLogs()
  },
  methods: {
    // 加载统计信息
    async loadStats() {
      try {
        const response = await this.$get('/login-logs/stats')
        if (response.data && response.data.code === 200) {
          this.stats = response.data.data
        }
      } catch (error) {
        console.error('加载统计信息失败:', error)
      }
    },
    
    // 加载日志列表
    async loadLogs() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        
        // 添加筛选参数
        if (this.filterForm.username) {
          params.username = this.filterForm.username
        }
        if (this.filterForm.status !== '') {
          params.status = this.filterForm.status
        }
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          params.startDate = this.filterForm.dateRange[0]
          params.endDate = this.filterForm.dateRange[1]
        }
        
        const response = await this.$get('/login-logs/list', params)
        if (response.data && response.data.code === 200) {
          const data = response.data.data
          this.logs = data.list || []
          this.pagination.total = data.total || 0
        } else {
          this.$message.error(response.data?.msg || '加载失败')
        }
      } catch (error) {
        console.error('加载日志列表失败:', error)
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    
    // 筛选
    handleFilter() {
      this.pagination.page = 1
      this.loadLogs()
      this.loadStats()
    },
    
    // 重置
    handleReset() {
      this.filterForm = {
        username: '',
        status: '',
        dateRange: []
      }
      this.pagination.page = 1
      this.loadLogs()
      this.loadStats()
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.loadLogs()
    },
    
    // 页码改变
    handleCurrentChange(page) {
      this.pagination.page = page
      this.loadLogs()
    },
    
    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      return time.replace('T', ' ').substring(0, 19)
    }
  }
}
</script>

<style scoped>
.login-logs-container {
  /*padding: 20px;*/
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.title i {
  margin-right: 5px;
  color: #409EFF;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-form {
  margin: 0;
}

.stats-section {
  margin-bottom: 20px;
}

.stat-card {
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: white;
  text-align: center;
}

.stat-card.success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.stat-card.failed {
  background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%);
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>


